import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';

import { ConvenioService } from 'src/app/services/convenio/convenio.service';

import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';


export interface DialogData
{
    idPostulacion: any,
    asientoContable: any,
    email: any,
    nombreCompleto: any,
    nombreProducto: any,
    comentarioRechazo: any
}

@Component({
    selector: 'anular-convenio',
    templateUrl: '../../pages/convenio/convenio-anular.html',
    styleUrls: ['../../pages/convenio/convenio.component.css']
})
export class DialogAnularConvenio
{


  constructor( public dialogRef: MatDialogRef<DialogAnularConvenio>,
    private convenioService: ConvenioService,
   
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog, )
    { 
      
    
    }
    
    ngOnInit(): void
    { this.loadData() }
    loadData()
    {
     
    }
    onAnularReversar(){
      let postulacionID = this.data.idPostulacion
      let numeroTexto = this.data.asientoContable
    
    let vm= this;

    if(this.data.asientoContable == '')
    {   
        this.openAlertDialog('Debe ingresar el asiento contable.', 'btn-danger')
        return false
    }
    this.convenioService.anularReversarConvenio(this.data.idPostulacion,
       this.data.asientoContable,localStorage.getItem("idUsuario")).then(
      () =>
      {
       Swal.close();
         this.dialogRef.close()
         this.openAlertDialog('El convenio se ha anulado/reversado exitosamente.', 'btn-success')
      }
    )
    .catch
    (
      error =>
      {
       Swal.close();
         console.log(error)
         vm.dialogRef.close()
         vm.openAlertDialog('La postulación no se ha podido anular.', 'btn-danger')
      }
    )
    }
    
    onCancelarClick(): void { this.dialogRef.close() }
    
    openAlertDialog(mensaje: string, clase: string)
    {
    this.dialog.open(AlertDialogComponent, {
    data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
      })
      }
    }
    